import { useAuthStore } from "@/modules/auth/store/auth.store";

/**
 * Permission tekshiruvi. Rollar DB'da dinamik, shuning uchun rol nomiga qarab
 * tekshirmang — har doim `resource:action` juftligini so'rang.
 */
export function usePermission(): {
	can: (resource: string, action: string) => boolean;
	permissions: string[];
} {
	const permissions = useAuthStore((state) => state.user?.permissions);

	const list = permissions ?? [];

	return {
		permissions: list,
		can: (resource: string, action: string) => list.includes(`${resource}:${action}`),
	};
}
